import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'
import { hasToken,getRole } from '@/utils/auth'

// 导入页面组件
// import Home from '@/views/Home'
// import Login from '@/views/Login'
import Register from '@/views/Register'
import FileUpload from '@/views/FileUpload'
import MyFiles from '@/views/MyFiles'
import UserCenter from '@/views/UserCenter'
import UserManagement from '@/views/UserManagement'
import SharedFiles from '@/views/SharedFiles'
import RecycleBin from '@/views/RecycleBin'
import RecentViewed from '@/views/RecentViewed'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false } // 不需要登录
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue'),
      meta: { requiresAuth: true } // 需要登录
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { requiresAuth: false }
    },
    {
      path: '/user/center',
      name: 'UserCenter',
      component: UserCenter,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/user',
      name: 'UserManagement',
      component: UserManagement,
      meta: { requiresAuth: true }
    },
    // 快捷操作对应的路由（必须完整配置）
    {
      path: '/file/upload', // 上传文件
      name: 'FileUpload',
      component: FileUpload, // 确保组件存在
      meta: { requiresAuth: true }
    },
    {
      path: '/file/my-files', // 我的文件
      name: 'MyFiles',
      component: MyFiles,
      meta: { requiresAuth: true }
    },
    {
      path: '/file/shared', // 共享中心
      name: 'SharedFiles',
      component: SharedFiles,
      meta: { requiresAuth: true }
    },
    {
      path: '/file/recent', // 最近浏览
      name: 'RecentViewed',
      component: RecentViewed,
      meta: { requiresAuth: true }
    },
    {
      path: '/file/recycle', // 回收站
      name: 'RecycleBin',
      component: RecycleBin,
      meta: { requiresAuth: true }
    },
    // 404页面
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 路由守卫：判断是否登录
router.beforeEach((to, from, next) => {
  // 1. 不需要登录的页面（如登录页），直接放行
  if (!to.meta.requiresAuth) {
    next()
    return
  }
  
  // 2. 需要登录的页面：检查是否有token
  if (hasToken()) {
    if(getRole() === 'guest') {
      if (to.path === '/file/shared') {
        next();
      } else {
        // 使用replace避免添加历史记录
        next({ path: '/file/shared', replace: true });
      }
    } else{
      next()
    }
  } else {
    // 无token：强制跳转到登录页
    next('/login')
  }
})

export default router